'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _CaretUpFilled = _interopRequireDefault(require('./lib/icons/CaretUpFilled'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _CaretUpFilled.default || _CaretUpFilled;
  exports.default = _default;
  module.exports = _default;